import { useState } from 'react';
import showToast from '../components/ToastComponent';
import { previewTrainingTools } from '../service/previewTrainingTools';
import { useQuery } from '@tanstack/react-query';
import { selectedResourceInterface } from '../interface/interface';

export function useToPreviewTrainingTools(token: string) {
  const [profileName, setProfileName] = useState<string | null>(null);
  const [previewBlob, setPreviewBlob] = useState<Blob | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>();
  const [activeButtonIndex, setActiveButtonIndex] = useState<string>();
  const [selectedResource, setSelectedResource] =
    useState<selectedResourceInterface | null>(null);

  const { isFetching: isPreviewLoading } = useQuery({
    queryKey: ['previewTrainingTools', selectedResource?.resourceId],
    queryFn: async () => {
      const result = await previewTrainingTools(
        token,
        selectedResource!.resourceId,
      );

      if (typeof result === 'number') {
        showToast({
          type: 'info',
          message: 'Unable to Preview resource files',
        });
        return;
      }

      const url = URL.createObjectURL(result);
      setPreviewBlob(result);
      setProfileName(selectedResource!.profileName);
      setPreviewUrl(url);
      setActiveButtonIndex(undefined);

      return result;
    },
    enabled: !!selectedResource,
  });

  function handlePreviewFiles(resourceId: string, profileName: string) {
    setActiveButtonIndex(resourceId);
    setSelectedResource({ resourceId, profileName });
  }

  function closePreview() {
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }
    setPreviewUrl(null);
    setProfileName(null);
    setPreviewBlob(null);
    setActiveButtonIndex(undefined);
    setSelectedResource(null);
  }

  return {
    handlePreviewFiles,
    previewUrl,
    profileName,
    previewBlob,
    closePreview,
    activeButtonIndex,
    isPreviewLoading,
  };
}
